import { useEffect } from "react";
import "./SorryMessageModal.css";

function WarningIcon() {
  return (
    <div className="sorry-modal__icon-wrap" aria-hidden>
      <span className="sorry-modal__ray sorry-modal__ray--top" />
      <span className="sorry-modal__ray sorry-modal__ray--left" />
      <span className="sorry-modal__ray sorry-modal__ray--right" />
      <span className="sorry-modal__icon-circle">
        <svg className="sorry-modal__warn" viewBox="0 0 48 48" fill="none">
          <path
            d="M24 6.5 42.5 39.5H5.5L24 6.5Z"
            fill="currentColor"
            opacity="0.18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path d="M24 18v11" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
          <circle cx="24" cy="34.5" r="2.2" fill="currentColor" />
        </svg>
      </span>
    </div>
  );
}

function RetryIcon() {
  return (
    <svg className="sorry-modal__btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M16.5 10a6.5 6.5 0 1 1-1.9-4.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path d="M16.5 4.5V9h-4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * Soft warning / apology modal for marketplace availability errors.
 */
export default function SorryMessageModal({
  open,
  title = "We're sorry!",
  message,
  actionLabel = "Got it",
  onAction,
  onClose,
  elevated = false,
}) {
  useEffect(() => {
    if (!open) return undefined;
    function onKeyDown(event) {
      if (event.key === "Escape") onClose?.();
    }
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  function handleAction() {
    if (onAction) onAction();
    else onClose?.();
  }

  return (
    <div
      className={`sorry-modal${elevated ? " sorry-modal--above-booking" : ""}`}
      role="presentation"
    >
      <button type="button" className="sorry-modal__backdrop" aria-label="Close" onClick={onClose} />
      <div
        className="sorry-modal__panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="sorry-modal-title"
        aria-describedby="sorry-modal-message"
      >
        <button type="button" className="sorry-modal__close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden>
            <path d="M5 5l10 10M15 5 5 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>

        <div className="sorry-modal__body">
          <WarningIcon />
          <h2 id="sorry-modal-title" className="sorry-modal__title">
            {title}
          </h2>
          <span className="sorry-modal__rule" aria-hidden />
          <p id="sorry-modal-message" className="sorry-modal__message">
            {message}
          </p>
        </div>

        <div className="sorry-modal__footer">
          <button type="button" className="sorry-modal__action" onClick={handleAction}>
            <RetryIcon />
            <span>{actionLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
